export class PriceMatchPromise {
	constructor() {
		this.selectors = {
			modal_trigger_attr: "price-match-trigger",
			modal_attr: "[price-match-promise-modal]",
			product_handle_attr: 'data-product',
			variant_select_section: 'gb-price-match-variant-select',
			product_options_attr: 'data-product-options',
			product_validation_attr: 'product-validation',
			product_false_text_attr: 'data-product-false-text',
			product_invalid_text: 'data-invalid-product-text',
			product_url_input: '#price-promise-product-url',
			form_submit_attr: 'submit-button',
			product_url_valid_icon_attr: 'valid-url-icon',
			product_url_invalid_icon_attr: 'invalid-url-icon',
			unavailable_message: '[unavailable-message]',
			metafieldOption1: 'data-option-1',
			metafieldOption2: 'data-option-2',
			metafieldOption3: 'data-option-3',
			metafieldOption4: 'data-option-4',
			product_availablity_input: '#pricePromiseProductAvailablity'
		};
		this.init();
	}

	init() {
		this.modal = document.querySelector(this.selectors.modal_attr);
		if (this.modal) {
			this.product_options_el = this.modal.querySelector(`[${this.selectors.product_options_attr}]`);
			this.product_validation_el = this.modal.querySelector(`[${this.selectors.product_validation_attr}]`);
			this.product_false_text = this.product_validation_el.getAttribute(this.selectors.product_false_text_attr);
			this.product_invalid_text = this.product_validation_el.getAttribute(this.selectors.product_invalid_text);
			this.product_url_input = this.modal.querySelector(this.selectors.product_url_input);
			this.form_submit_button = this.modal.querySelector(`[${this.selectors.form_submit_attr}]`);
			this.product_url_valid_icon = this.modal.querySelector(`[${this.selectors.product_url_valid_icon_attr}]`);
			this.product_url_invalid_icon = this.modal.querySelector(`[${this.selectors.product_url_invalid_icon_attr}]`);
			this.unavailable_message = this.modal.querySelector(this.selectors.unavailable_message);
			this.product_availablity_input = this.modal.querySelector(`${ this.selectors.product_availablity_input }`);
			this.metafieldOptions = [];
		}
		document.body.addEventListener('click', this.handleEvent.bind(this));
		document.body.addEventListener('change', this.handleInputChange.bind(this));
		document.body.addEventListener('keyup', this.handleInputURL.bind(this));

		this.showSubmittedModal();
	}

	handleInputChange(e) {
		this.inputOptionChange(e);
	}

	handleInputURL(e) {
		this.productURLInputChange(e);
	}

	handleEvent(e) {
		this.openModal(e);
	}

	// Open modal if #price-match-submitted is in the url
	showSubmittedModal() {
		const url = window.location.href;
		if (url.includes('#price-match-submitted')) {
			this.modal.classList.add('active');
		}
	}

	openModal(e) {
		if (!this.modal) {
			console.error('Modal not found');
			return;
		}
		if (e.target.hasAttribute(this.selectors.modal_trigger_attr)) {
			this.modal.classList.add('active');
			this.checkProductHandle(e.target);
		}
	}

	inputOptionChange(e) {
		if (!e.target.classList.contains('form-control')) {
			return;
		}
		// get option values and get variant id
		this.getOptionValues();
	}

	productURLInputChange(e) {
		if (e.target.id != this.selectors.product_url_input.replace('#', '')) {
			return;
		}
		// get product handle from value
		const product_handle = e.target.value.split('/products/').pop().split('?variant=')[0];
		const variant_id = e.target.value.split('/products/').pop().split('?variant=')[1];
		if (variant_id) {
			this.getProductJSON(product_handle, variant_id);
		} else if (product_handle) {
			this.getProductJSON(product_handle);
		}
	}

	getOptionValues() {
		const selects = this.product_options_el.querySelectorAll('select');
		const option_values = [];
		selects.forEach((select) => {
			option_values.push(select.value);
		});
		this.getVariantId(option_values);
	}

	// get variant id based on option values
	getVariantId(option_values) {
		const variant = this.product_options.find((variant) => {
			return variant.option1 == option_values[0] && variant.option2 == option_values[1] && variant.option3 == option_values[2];
		});
		if (variant) {
			this.validateProduct(true, variant.variant_id);
			if (variant.available == false) {
				this.showOOSError(true);
			} else {
				this.showOOSError(false);
			}
		} else {
			this.validateProduct(false);
			console.warn('Variant not found for option values:', option_values);
		}
	}

	displayProductOptions(validation) {
		if (validation) {
			this.product_options_el.style.display = 'flex';
		} else {
			this.product_options_el.style.display = 'none';
		}
	}

	validateProduct(exists, variant_id) {
		if (exists) {
			this.setVariantIDURL(variant_id);
			this.product_validation_el.innerHTML = '';
			this.product_validation_el.classList.remove('invalid');
			this.form_submit_button.disabled = false;
			this.product_url_valid_icon.style.display = 'block';
			this.product_url_invalid_icon.style.display = 'none';
		} else {
			this.product_validation_el.innerHTML = this.product_false_text;
			this.product_validation_el.classList.add('invalid');
			this.form_submit_button.disabled = true;
			this.product_url_valid_icon.style.display = 'none';
			this.product_url_invalid_icon.style.display = 'block';
		}
	}

	validateProductURL(exists) {
		if (exists) {
			this.product_validation_el.innerHTML = '';
			this.product_validation_el.classList.remove('invalid');
			this.form_submit_button.disabled = false;
			// this.displayProductOptions(true);
			this.product_url_invalid_icon.style.display = 'none';
			this.product_url_valid_icon.style.display = 'block';
		} else {
			this.product_validation_el.innerHTML = this.product_invalid_text;
			this.product_validation_el.classList.add('invalid');
			this.form_submit_button.disabled = true;
			this.product_url_invalid_icon.style.display = 'block';
			this.product_url_valid_icon.style.display = 'none';
			// this.displayProductOptions(false);
		}
	}

	setVariantIDURL(variant_id) {
		const url = this.product_url_input.value;
		const new_url = url.split('?variant=')[0] + `?variant=${variant_id}`;

		this.setProductURLValue(new_url);
	}

	checkProductHandle(target) {
		const product_handle = target.getAttribute(this.selectors.product_handle_attr);
		const metaOption1 = target.getAttribute(this.selectors.metafieldOption1);
		const metaOption2 = target.getAttribute(this.selectors.metafieldOption2);
		const metaOption3 = target.getAttribute(this.selectors.metafieldOption3);
		const metaOption4 = target.getAttribute(this.selectors.metafieldOption4);
		
		// Add to an array and return
		if ( metaOption1 || metaOption2 || metaOption3 || metaOption4 ) {
			this.metafieldOptions = [];
			if ( metaOption1 ) this.metafieldOptions.push(metaOption1);
			if ( metaOption2 ) this.metafieldOptions.push(metaOption2);
			if ( metaOption3 ) this.metafieldOptions.push(metaOption3);
			if ( metaOption4 ) this.metafieldOptions.push(metaOption4);
		} 

		if ( product_handle == 'true' ) {
			this.getURL( this.metafieldOptions );
		}
	}

	getURL() {
		const url = new URL(window.location.href);
		const product_handle = url.pathname.split('/products/').pop().split('/')[0];
		const variant_id = url.searchParams.get('variant');
		
		this.getProductJSON(product_handle, variant_id);
		this.setProductURLValue(url.href);
	}

	setProductURLValue(url) {
		this.product_url_input.value = url;
	}

	getProductJSON(product_handle, variant_id) {
		// fetch(window.Shopify.routes.root + `products/${product_handle}.js`)
		fetch(window.Shopify.routes.root + `products/${product_handle}?view=pricePromiseData&section_id=gb-product-json`)
			.then((response) => {
				if (!response.ok) {
					this.validateProductURL(false);
					return;
				}
				return response.text();
			})
			.then((data) => {
				const htmlDocument = new DOMParser().parseFromString(data, "text/html");
				const productData = JSON.parse( htmlDocument.querySelector('#productJSON').innerHTML );
				// console.log('🚀🚀🚀 RESPONSE DATA: ', productData );
				this.displayProductOptions(false);
				
				if ( !data || ! productData ) {
					return;
				}
				
				
				let productAvailable = false;
				this.metafieldOptions = [];
				if ( productData.webdropdown1label ) this.metafieldOptions.push( productData.webdropdown1label );
				if ( productData.webdropdown2label ) this.metafieldOptions.push( productData.webdropdown2label );
				if ( productData.webdropdown3label ) this.metafieldOptions.push( productData.webdropdown3label );
				if ( productData.webdropdown4label ) this.metafieldOptions.push( productData.webdropdown4label );
				

				if (productData.variants.length > 1) {
					// Ensure optionsSelects returns a value
					this.product_options = this.optionsSelects( productData, this.metafieldOptions);
					if (!this.product_options) {
						console.log('optionsSelects returned undefined or null');
					}

					// Ensure variantOptionsObj returns a value
					this.product_options = this.variantOptionsObj( productData );
					if (!this.product_options) {
						console.error('variantOptionsObj returned undefined or null');
					}

					// validate product
					this.validateProductURL(true);

					// Set product availablity
					if ( this.product_availablity_input ) this.product_availablity_input.value = productData.available;
					
					// set selected options based on variant_id
					if (variant_id) {
						this.setVariantOptions(variant_id);
						this.displayIfUnavailable(productData, variant_id);
						
						// If Variant Set variant Availablity
						let selectedVariant = productData.variants.find( variant => variant.id === Number( variant_id ) );
						// console.log('selectedVariant: ', selectedVariant, ' | variant_id: ', variant_id, ' | productData Variants: ', productData.variants);
						if ( selectedVariant && selectedVariant.available == true ) {
							this.product_availablity_input.value = true;
							productAvailable = true;
						} else {
							this.product_availablity_input.value = false;
							productAvailable = false;
						} 
					}

					// find variant_id in product object and find if available
					this.checkVariantAvailability(productData, variant_id);
					// this.displayProductOptions(true);
					
				} else {
					// this.product_options_el.style.marginBottom = '0';
					// this.displayProductOptions(false);
					
					console.log('Product has only one variant', productData.available);
					if (productData.available == false) {
						this.showOOSError(true);
						if ( this.product_availablity_input ) this.product_availablity_input.value = productData.available;
					} else {
						this.showOOSError(false);
						this.validateProductURL(true);
						if ( this.product_availablity_input ) this.product_availablity_input.value = productData.available;
					}
					productAvailable = productData.available;
				}
				
				if ( productAvailable && productData.variants.length > 1 ) {
					this.displayProductOptions(true);
					// console.log('SHOW Variant Options!');
				} else {
					this.displayProductOptions(false);
					// console.log('HIDE Variant Options!');
				}
				console.log('productAvailable: ', productAvailable, ' | productData.variants.length: ', productData.variants.length );
				

			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	displayIfUnavailable(product, variant_id) {
		// Find variant by variant id in product object
		const variant = product.variants.find((variant) => {
			return variant.id == variant_id;
		});
	}

	checkVariantAvailability(data, variant_id) {
		// if (!this.setVariantOptions(variant_id)) {
		// 	console.log('setVariantOptions returned false');
		// 	return;
		// }
		const variant = data.variants.find(v => v.id == variant_id);
		// console.log('Variant availabilty:', variant.available);
		if (variant.available == false) {
			this.showOOSError(true);
		} else {
			this.showOOSError(false);
		}
	}

	showOOSError(available) {
		if (!available) {
			this.unavailable_message.style.display = 'none';
		} else {
			this.unavailable_message.style.display = 'flex';
		}
	}

	optionsSelects(product, optionsSelects) {
		// console.log('🚀🚀 product: ', product, '  |  options: ', optionsSelects )
		const productOptions = product.options_with_values.map((option, index) => {
			return {
				name: option.name,
				values: option.values,
			};
		});
		// console.log('🚀🚀 productOptions: ', productOptions );

		if (productOptions.length < 2) {
			console.log('Product options length is less than 2:', productOptions);
			return;
		}

		this.product_options_el.innerHTML = '';

		productOptions.forEach((option, i) => {

			const div = document.createElement('div');
			div.classList.add('form-group');

			const label = document.createElement('label');
			if (optionsSelects[i]) {
				label.for = optionsSelects[i];
				label.innerHTML = optionsSelects[i];
			} else {
				label.for = option.name;
				label.innerHTML = option.name;
			}

			const select = document.createElement('select');
			if (optionsSelects[i]) {
				select.name = `contact[${optionsSelects[i]}]`;
				select.id = optionsSelects[i];
			} else {
				select.name = `contact[${option.name}]`;
				select.id = option.name;
			}
			select.classList.add('form-control');
			select.innerHTML = option.values.map(value =>
				`<option value="${value}">${value}</option>`
			).join('');

			div.appendChild(label);
			div.appendChild(select);
			this.product_options_el.appendChild(div);
		});
		return productOptions;
	}

	variantOptionsObj(product) {
		if (!product || !product.variants) {
			console.error('Invalid product format:', product);
			return [];
		}

		const variant_options = product.variants.map((variant) => {
			return {
				variant_id: variant.id,
				option1: variant.option1,
				option2: variant.option2,
				option3: variant.option3,
				available: variant.available
			};
		});
		return variant_options;
	}

	setVariantOptions(variant_id) {
		if (!this.product_options) {
			// this.product_options_el.style.marginBottom = '0';
			console.log('product_options is undefined');
			return false;
		}

		const variant = this.product_options.find((variant) => {
			return variant.variant_id == variant_id;
		});

		if (variant) {
			this.setVariantSelects(variant);
			this.validateProductURL(true);
		} else {
			this.validateProductURL(false);
			console.warn('Variant not found for variant_id:', variant_id);
		}
	}

	setVariantSelects(variant) {
		const selects = this.product_options_el.querySelectorAll('select');
		selects.forEach((select, index) => {
			const options = select.querySelectorAll('option');
			const optionValue = variant[`option${index + 1}`]; // Get the corresponding option value from the variant
			if (optionValue !== null) {
				options.forEach((option) => {
					if (option.value === optionValue) {
						select.value = optionValue;
					}
				});
			} else {
				console.warn(`Variant option${index + 1} is null`);
			}
		});
	}
}